import * as React from 'react'
import { FC } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { FullScreenDialog } from '../FullScreenDialog'
import { ServiceDialogContent } from './ServiceDialogContent'
import { LocationDTO } from '@sales-center/common'
import { ServiceDialogRemoteContentWrapper } from './ServiceDialogRemoteContentWrapper'

type BaseProps = {
  address: string
  branchId: string
  closeButtonText?: string
  deleteServiceWarningMessage?: string
  entityType: ENTITY_TYPES
  minimumServicesCount?: number
  onClose: () => void
  open: boolean
  openAddServiceDrawerOnMount?: boolean
  readOnly?: boolean
  referralDiscountId?: string
  totalServicesCount?: number
  useSystemName?: boolean
}

export type ServiceDialogLocalProps = BaseProps & {
  serviceLocations: LocationDTO[]
  locationSource: 'new'
}

export type ServiceDialogRemoteProps = BaseProps & {
  entityId: number
  locationSource: 'existing'
  // WWM-18150 - when the caller already has this entity's current service locations loaded
  // (e.g. the Opportunity/Lead Details page, which only renders once its own detail fetch has
  // resolved), pass them through here so ServiceDialogRemoteContentWrapper can skip its own
  // independent, race-prone fetch. Omitted by callers without pre-loaded data (e.g. the
  // card-view modal), which keep using that fetch as before.
  preloadedServiceLocations?: LocationDTO[]
}

export type ServiceDialogProps =
  | ServiceDialogLocalProps
  | ServiceDialogRemoteProps

export const ServiceDialog: FC<ServiceDialogProps> = (props) => {
  const {
    open,
    onClose,
    closeButtonText = 'Close Services and Products',
  } = props

  return (
    <FullScreenDialog
      open={open}
      onClose={onClose}
      closeButtonText={closeButtonText}
    >
      {props.locationSource === 'new' ? (
        <ServiceDialogContent entityId={-1} {...props} />
      ) : (
        <ServiceDialogRemoteContentWrapper {...props} />
      )}
    </FullScreenDialog>
  )
}
ServiceDialog.displayName = 'ServiceDialog'
